import deUnderscore from '../utils/deUnderscore'

export default function posProductFieldMapFactory(taxonomyMap) {
  const mapTaxonomyToValue = (value, field) => {
    try {
      return taxonomyMap[field].filter(item => item.name === value)[0].description
    }
    catch (err) {
      return 'unknown'
    }
  }

  return {
    productCategory: function(store) {
      if (this.hasOwnProperty('posProductCategory') && this.posProductCategory !== '') {
        return mapTaxonomyToValue(this.posProductCategory, 'pos_product_category')
      } else {
        return ''
      }
    }
  }
}
